import { render, staticRenderFns } from "./ConsentOTP.vue?vue&type=template&id=61a53d9a"
import script from "./ConsentOTP.vue?vue&type=script&lang=js"
export * from "./ConsentOTP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports